import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tag } from '@base-app';
import { StyledListItem, TeamsListItemStyled, TeamsListMobileStyled } from './TeamsListMobile.styles';
import { TeamsListMobileProps } from './TeamsListMobile.types';
import { TeamListItem } from '@modules/teams/types/TeamListItem';
import { TEAMS_TRANSLATION } from '@modules/teams/constants';
import { intlFormatDistance } from 'date-fns';
import { UserStatuses } from '@modules/teams/types';
import TeamsListItemDropdown from '../TeamsListItemDropdown/TeamsListItemDropdown';
import { isSSOUser } from '@modules/core/utils';
import useOrganizationName from '@/modules/my-account/hooks/useOrganizationName';

const TeamsListMobile: FC<TeamsListMobileProps> = ({
  currentUser,
  data,
  onDeactivate,
  onDelete,
  onMFAReset,
  onPasswordReset,
  onReactivate,
  onUpdate,
}) => {
  const organizationName = useOrganizationName();
  const { t } = useTranslation(TEAMS_TRANSLATION);

  const statusOrRole = (item: TeamListItem): ReactNode =>
    item.status === UserStatuses.DEPROVISIONED ? (
      <Box css={{ color: '$red' }}>{t('deactivated')}</Box>
    ) : (
      item.profile.pp_role
    );

  const handleUpdate = (userId: string, user: any): void => {
    const userToEdit = { ...user, id: userId, role: { id: user.pp_role } };
    onUpdate(userToEdit);
  };

  return (
    <TeamsListMobileStyled>
      <ul>
        {data?.map((item: TeamListItem, index: number) => {
          return (
            <TeamsListItemStyled key={index}>
              <Box
                css={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <ul>
                  <StyledListItem title={`${item.profile.firstName} ${item.profile.lastName}`}>
                    {`${item.profile.firstName} ${item.profile.lastName}`}
                    {currentUser?.id === item.id && (
                      <Tag css={{ marginLeft: '$2' }}>{t('you', { ns: 'teams' }).toUpperCase()}</Tag>
                    )}
                  </StyledListItem>
                  <StyledListItem title={item.profile.email}>{item.profile.email}</StyledListItem>
                  <li>{statusOrRole(item)}</li>
                  <li>
                    {t('last_seen')}&nbsp;
                    {item.lastLogin
                      ? intlFormatDistance(new Date(item.lastLogin), new Date())
                      : t('awaiting_activation', { ns: 'teams' })}
                  </li>
                </ul>
                {currentUser && organizationName && !isSSOUser(currentUser, organizationName) && (
                  <TeamsListItemDropdown
                    user={item}
                    onDeactivate={() => onDeactivate(item.id)}
                    onDelete={() => onDelete(item.id)}
                    onPasswordReset={() => onPasswordReset(item.id)}
                    onReactivate={() => onReactivate(item.id)}
                    onMFAReset={() => onMFAReset(item.id)}
                    onUpdate={() => handleUpdate(item.id, item.profile)}
                  />
                )}
              </Box>
            </TeamsListItemStyled>
          );
        })}
      </ul>
    </TeamsListMobileStyled>
  );
};

export default TeamsListMobile;
